import LeslieYee from "@assets/newsletter/leslie20yee.png";
import LinkedinIcon from "@assets/newsletter/nl-byline-linkedin-icon.png";

export default function PropertyInsightNewsletterSampleAuthor(): React.ReactElement {
  return (
    <>
      <div className="m-0 mx-auto my-3 box-border w-full max-w-4xl p-0 py-2.5">
        <div className="flex flex-wrap items-center justify-center">
          <div className="pr-2">
            <img
              className="user_profile_img relative h-auto max-w-full rounded-full"
              src={LeslieYee}
              width="70"
              height="70"
            />
          </div>
          <div className="items-center pt-2">
            <span className="font-helvetica block text-sm font-bold leading-5 text-black">
              Leslie Yee
            </span>
            <span className="font-helvetica block text-sm font-normal leading-5 text-black">
              Senior Correspondent
            </span>
            <a
              className="byline-link font-helvetica text-sm font-normal leading-5 text-black no-underline"
              href="https://www.linkedin.com/in/leslie-yee-8aa0b532/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className="email-img inline h-5 w-5 align-middle"
                alt="author linkedin"
                src={LinkedinIcon}
                width="20"
                height="20"
              />
              <div className="inline-block pl-1 align-middle">Leslie Yee</div>
            </a>
          </div>
        </div>
      </div>
      <div className="mx-5 mt-6 border-t-[3px] border-gray-250 pb-6" />
    </>
  );
}
